import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AppDescribtionPage } from '../../AppDescribtion/AppDescribtion';
import { CurcessPage } from '../Curcess/Curcess';
import { TeachingResourcesPage } from '../TeachingResources/TeachingResources';

/*
  Generated class for the AcademyHome page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-AcademyHome',
    templateUrl: 'AcademyHome.html'
})
export class AcademyHomePage {

    constructor(public navCtrl: NavController, public navParams: NavParams) { }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AcademyHomePage');
    }
    About() {
        this.navCtrl.push(AppDescribtionPage, { Title: "درباره آکادمی فولاد ایران", Color: "yellow", Text: "AcademyAbout.txt" });
    }
    Teaching() {
        //this.navCtrl.push(AppDescribtionPage, { Title: "مطالب آموزشی", Color: "yellow", Text: "AcademyLerning.txt" });
        this.navCtrl.push(TeachingResourcesPage);
    }
    Curcess() {
        this.navCtrl.push(CurcessPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/academy/AcademyHome/AcademyHome.ts